module.exports = __webpack_public_path__ + "img/bell2x.png?1ad97cf18a493587fe715e2f5ab12575";